import { useCallback, useEffect, useState } from 'react';
import type { DirectoryData } from '../typing.d.ts';

/**
 * 平铺目录数据管理的自定义 Hook
 * @description 管理目录数据和展开状态
 * @param initialData - 初始目录数据
 * @param externalExpanded - 外部传入的展开状态
 * @returns {Object} 返回目录数据和状态控制
 */
export const useTiledDirectory = (initialData: DirectoryData, externalExpanded?: boolean) => {
    // 存储目录数据
    const [data, setData] = useState<DirectoryData>(initialData);
    // 内部维护的展开状态
    const [internalExpanded, setInternalExpanded] = useState<boolean>(true);

    /**
     * 监听初始数据变化，更新本地数据
     */
    useEffect(() => {
        setData(initialData);
    }, [initialData]);

    /**
     * 切换展开状态
     */
    const toggleExpand = useCallback(() => {
        setInternalExpanded((prev: boolean) => !prev);
    }, []);

    // 优先使用外部传入的展开状态
    const isExpanded = externalExpanded ?? internalExpanded;

    return {
        data,           // 目录数据
        isExpanded,     // 当前展开状态
        toggleExpand,   // 切换展开状态的方法
    };
}; 